import { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { useSelector } from 'react-redux';
import { throttleRAF } from '../../../utils/throttle';
import { getObjectById } from '../../../utils/getObjectById';

// Helper: Scene içinde recursive olarak obje bul
const findObjectInScene = (scene, predicate) => {
  let result = null;
  scene.traverse(obj => {
    if (!result && predicate(obj)) {
      result = obj;
    }
  });
  return result;
};
 
export default function useSocketGizmoEvents({ scene, camera, renderer }) {
  const rotatingSocketRef = useRef(null);
  const stretchingSocketRef = useRef(null);
  const startAngleRef = useRef(0);
  const startRotationZRef = useRef(0);
  const startStretchYRef = useRef(0);
  const startMouseYRef = useRef(0);
  const movingSocketRef = useRef(null);
  const targetLineRef = useRef(null);
  const grabOffsetRef = useRef(new THREE.Vector3());

  const orthoMode = useSelector((state) => state.mods.orthoMode);

  useEffect(() => {
    if (!scene || !camera || !renderer) return;

    const dom = renderer.domElement;
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    const getWorldPoint = (event) => {
      const rect = dom.getBoundingClientRect();
      mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);

      const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
      const point = new THREE.Vector3();
      raycaster.ray.intersectPlane(plane, point);
      return point;
    };

    
    const handleMouseDown = (event) => {
      const point = getWorldPoint(event);
      const intersects = raycaster.intersectObjects(scene.children, true);

      const rotateHit = intersects.find(i =>
        i.object?.userData?.type === 'rotateGizmo' &&
        i.object?.userData?.parentSocketId // Sadece socket gizmo'larını yakala
      );
      if (rotateHit) {
        const parentId = rotateHit.object.userData.parentSocketId;
        

        const socketGroup = findObjectInScene(scene, obj => obj.userData?.id === parentId && obj.userData?.type === 'socket');

        if (!socketGroup) {
          console.error('❌ socketGroup bulunamadı! Aranan parentId:', parentId);
          return;
        }

        

        // offsetGroup'u userData.isOffsetGroup ile bul
        const offsetGroup = socketGroup?.children.find(child => child.userData?.isOffsetGroup === true);

        if (!offsetGroup) {
          console.warn('⚠️ offsetGroup bulunamadı! socketGroup children:', socketGroup.children.length);
          socketGroup.children.forEach((child, idx) => {
            
          });
          return;
        }

        

        // socket fpMesh-child olabilir (mesh-FP), .position LOCAL döner —
        // point WORLD olduğundan açı için socket'in dünya konumu gerekli.
        const center = socketGroup.getWorldPosition(new THREE.Vector3());
        const startVector = new THREE.Vector2(point.x - center.x, point.y - center.y);
        startAngleRef.current = Math.atan2(startVector.y, startVector.x);
        startRotationZRef.current = offsetGroup.rotation.z;
        rotatingSocketRef.current = offsetGroup;
        return;
      }

      const stretchHit = intersects.find(i => i.object?.userData?.type === 'stretchGizmo');
      if (stretchHit) {
        const parentId = stretchHit.object.userData.parentSocketId;
        

        const socketGroup = findObjectInScene(scene, obj => obj.userData?.id === parentId && obj.userData?.type === 'socket');
        // offsetGroup'u userData.isOffsetGroup ile bul
        const offsetGroup = socketGroup?.children.find(child => child.userData?.isOffsetGroup === true);
        if (!offsetGroup) {
          console.warn('⚠️ Stretch: offsetGroup bulunamadı!');
          return;
        }

        const initialStretch =
          offsetGroup.userData?.stretchLength ??
          socketGroup.userData?.stretchLength ??
          0;

        startStretchYRef.current = initialStretch;
        startMouseYRef.current = point.y;
        stretchingSocketRef.current = offsetGroup;

        
        return;
      }
      

      // ⚠️ MOVE GIZMO ŞİMDİLİK İPTAL (geçici olarak devre dışı)
      /*
      const moveHit = intersects.find(i => i.object?.userData?.type === 'moveGizmo');
      if (moveHit) {

        const parentSocketId = moveHit.object.userData.parentSocketId;

        const socketGroup = getObjectById(scene, parentSocketId);
        if (!socketGroup) return;
        const worldPoint = getWorldPoint(event);
        grabOffsetRef.current = new THREE.Vector3().subVectors(socketGroup.position, worldPoint);

        const branchID = socketGroup.userData?.branchID;
        if (!branchID) return;

         let targetLine = null;
scene.traverse(obj => {
  if (obj.userData.branchID === branchID) {
    targetLine = obj;
  }
});
if (!targetLine) {
  console.warn("❌ targetLine sahnede bulunamadı!");
}
        if (!targetLine || !targetLine.geometry) return;
        movingSocketRef.current = socketGroup;
        targetLineRef.current = targetLine;
      }
      */

      // Buat ile sürükleme
      const buatHit = intersects.find(i => i.object?.userData?.type === 'buatCircle');
      if (buatHit) {

        const socketUUID = buatHit.object.userData.socketUUID;

        const socketGroup = findObjectInScene(scene, obj => obj.uuid === socketUUID);

        if (!socketGroup) {
          console.warn("❌ Socket group bulunamadı, socketUUID:", socketUUID);
          return;
        }



        const worldPoint = getWorldPoint(event);
        grabOffsetRef.current = new THREE.Vector3().subVectors(socketGroup.position, worldPoint);

        // Buat'ın bağlı olduğu wire'ı bul
        let targetLine = null;
        scene.traverse(obj => {
          if (obj.userData?.type === 'wireSocket' &&
              obj.userData?.sockets &&
              obj.userData.sockets.includes(socketGroup.userData?.id)) {
            targetLine = obj;
          }
        });

        if (!targetLine || !targetLine.geometry) {
          console.warn("❌ Target line bulunamadı");
          return;
        }


        movingSocketRef.current = socketGroup;
        targetLineRef.current = targetLine;
      }


    };

    const handleMouseMove = (event) => {
      const point = getWorldPoint(event);

      if (rotatingSocketRef.current) {
        // socket fpMesh-child olabilir — parent.position LOCAL döner; point WORLD.
        // Açı için socket'in dünya konumunu kullan.
        const center = rotatingSocketRef.current.parent.getWorldPosition(new THREE.Vector3());
        const currentVector = new THREE.Vector2(point.x - center.x, point.y - center.y);
        let currentAngle = Math.atan2(currentVector.y, currentVector.x);

        if (orthoMode) {
          const rawDelta = currentAngle - startAngleRef.current;
          const deltaDeg = THREE.MathUtils.radToDeg(rawDelta);
          const snappedDeg = Math.round(deltaDeg / 45) * 45;
          currentAngle = startAngleRef.current + THREE.MathUtils.degToRad(snappedDeg);

        }

        const delta = currentAngle - startAngleRef.current;
        rotatingSocketRef.current.rotation.z = startRotationZRef.current + delta;
        // Yeni toplam açıyı derece cinsinden userData'ya kaydet
        const totalAngleDegrees = (startRotationZRef.current + delta) * 180 / Math.PI;
        rotatingSocketRef.current.parent.userData.rotate = totalAngleDegrees;
      }
      const gridSize = 5; // Stretch adımı

      if (stretchingSocketRef.current) {
        const offsetGroup = stretchingSocketRef.current;
        const socketGroup = offsetGroup.parent;
      
        let deltaY = point.y - startMouseYRef.current;

        // Dönme açısını normalize et (-π ~ π aralığına)
        let angle = stretchingSocketRef.current.rotation.z % (2 * Math.PI);
        if (angle < 0) angle += 2 * Math.PI;

        // 90° ile 270° arası ters yön (yani aşağıyı gösteriyorsa ters çevir)
        const isFlipped = angle > Math.PI / 2 && angle < (3 * Math.PI) / 2;
        if (isFlipped) deltaY = -deltaY;

        // Kademeli yap: 5 birim adımlarla yuvarla
        const steppedDeltaY = Math.round(deltaY / gridSize) * gridSize;
        const clampedDeltaY = Math.max(0, steppedDeltaY);

        // === line1 güncelle ===
        const line1 = stretchingSocketRef.current.children.find(
          (child) => child.userData?.role === 'line1'
        );
        if (line1) {
          const newLength = Math.max(21, 21 + clampedDeltaY);
          const points = [new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, newLength, 0)];
          line1.geometry.setFromPoints(points);
        }

        // === line2 güncelle (geometry yeniden yarat) ===
        const line2 = stretchingSocketRef.current.children.find(
          (child) => child.userData?.role === 'line2'
        );
        if (line2) {
          const newPoints = [
            new THREE.Vector3(-7, 21 + clampedDeltaY, 0),
            new THREE.Vector3(7, 21 + clampedDeltaY, 0)
          ];
          line2.geometry.dispose();
          line2.geometry = new THREE.BufferGeometry().setFromPoints(newPoints);
          line2.position.set(0, 0, 0); // Reset position
        }

        // === arc güncelle (geometry yeniden yarat) ===
        const arc = stretchingSocketRef.current.children.find(
          (child) => child.userData?.role === 'arc'
        );
        if (arc) {
          // Arc center at 28 + clampedDeltaY
          const arcRadius = 7;
          const arcCenter = new THREE.Vector3(0, 28 + clampedDeltaY, 0);
          const arcPoints = [];
          for (let i = 0; i <= 16; i++) {
            const angle = -Math.PI * (i / 16);
            const x = arcCenter.x + arcRadius * Math.cos(angle);
            const y = arcCenter.y + arcRadius * Math.sin(angle);
            arcPoints.push(new THREE.Vector3(x, y, 0));
          }
          arc.geometry.dispose();
          arc.geometry = new THREE.BufferGeometry().setFromPoints(arcPoints);
          arc.position.set(0, 0, 0); // Reset position
        }

        // === line3 (kapaklı priz) ===
        const line3 = stretchingSocketRef.current.children.find(
          (child) => child.userData?.role === 'line3'
        );
        if (line3) {
          const newPoints = [
            new THREE.Vector3(0, 21 + clampedDeltaY, 0),
            new THREE.Vector3(0, 28 + clampedDeltaY, 0),
            new THREE.Vector3(7, 28 + clampedDeltaY, 0)
          ];
          line3.geometry.setFromPoints(newPoints);
        }

        // === etanjFill ===
        const etanjFill = stretchingSocketRef.current.children.find(
          (child) => child.userData?.role === 'etanjFill'
        );
        if (etanjFill) {
          etanjFill.position.y = 28 + clampedDeltaY;
        }

        // === rotateGizmo ===
        const rotateGizmo = stretchingSocketRef.current.children.find(
          (child) => child.userData?.type === 'rotateGizmo'
        );
        if (rotateGizmo) {
          rotateGizmo.position.y = 33 + clampedDeltaY;
        }

        // === stretchGizmo ===
        const stretchGizmo = stretchingSocketRef.current.children.find(
          (child) => child.userData?.type === 'stretchGizmo'
        );
        if (stretchGizmo) {
          stretchGizmo.position.y = clampedDeltaY;
        }

        // === symetricGizmo ===
        const symetricGizmo = stretchingSocketRef.current.children.find(
          (child) => child.userData?.type === 'symetricGizmo'
        );
        if (symetricGizmo) {
          symetricGizmo.position.y = clampedDeltaY;
        }
        if (socketGroup) {
          socketGroup.userData.stretchLength = clampedDeltaY;
        }
        offsetGroup.userData.stretchLength = clampedDeltaY;
        
      }


      //--------------------
      // ⚠️ MOVE GIZMO ŞİMDİLİK İPTAL (geçici olarak devre dışı)
      /*
 
      if (movingSocketRef.current && targetLineRef.current) {
        const socketGroup = movingSocketRef.current;
        const line = targetLineRef.current;
         const worldPoint = getWorldPoint(event);
        const targetPos = new THREE.Vector3().addVectors(worldPoint, grabOffsetRef.current);
        socketGroup.position.copy(targetPos);
        let buat
        scene.traverse(obj => {
          if (obj.userData.socketUUID === socketGroup.uuid) buat = obj
        })


        const posAttr = line.geometry.attributes.position;
        if (!posAttr || posAttr.count < 2) return;

        let closestPoint = null;
        let closestDistance = Infinity;
        let bestDirection = null;

        const mousePoint = point.clone();

        for (let i = 0; i < posAttr.count - 1; i++) {
          const start = new THREE.Vector3().fromBufferAttribute(posAttr, i);
          const end = new THREE.Vector3().fromBufferAttribute(posAttr, i + 1);

          const segment = new THREE.Vector3().subVectors(end, start);
          const length = segment.length();
          const direction = segment.clone().normalize();

          const toMouse = new THREE.Vector3().subVectors(mousePoint, start);
          const projLength = toMouse.dot(direction);
          const clampedLength = THREE.MathUtils.clamp(projLength, 0, length);
          const projected = start.clone().add(direction.clone().multiplyScalar(clampedLength));

          const dist = projected.distanceTo(mousePoint);
          if (dist < closestDistance) {
            closestDistance = dist;
            closestPoint = projected;
            bestDirection = direction;
          }
        }

        if (closestPoint && bestDirection) {
          // 🟢 Soketi çizgiye hizala
          socketGroup.position.copy(closestPoint);

          // 🟢 Eğer buna bağlı bir buat objesi varsa, onu da taşı
          scene.traverse(obj => {
            if (obj.userData?.socketUUID === socketGroup.uuid) {
              obj.position.copy(closestPoint);
            }
          });

          // 🟢 Rotasyon: offsetGroup varsa döndür
          const offsetGroup = socketGroup.children.find(child => child.userData?.isOffsetGroup === true);
          if (offsetGroup) {
            const angle = Math.atan2(bestDirection.y, bestDirection.x);
            offsetGroup.rotation.z = angle;
            // userData.rotate'i de güncelle (degrees)
            socketGroup.userData.rotate = (angle * 180 / Math.PI);
          }

         }


      }
      */
      //-------------------------------


    };

    const handleMouseUp = () => {
      rotatingSocketRef.current = null;
      stretchingSocketRef.current = null;
      movingSocketRef.current = null;

    };

    const handleClick = (event) => {
      const point = getWorldPoint(event);
      const intersects = raycaster.intersectObjects(scene.children, true);
      const hit = intersects.find(i => i.object?.userData?.type === 'symetricGizmo');
      if (!hit) return;

      const parentId = hit.object.userData.parentSocketId;
      const socketGroup = findObjectInScene(scene, obj =>
        obj.userData?.id === parentId && obj.userData?.type === 'socket'
      );

      if (socketGroup && socketGroup.children.length > 0) {
        // offsetGroup'u userData.isOffsetGroup ile bul
        const offsetGroup = socketGroup.children.find(child => child.userData?.isOffsetGroup === true);
        if (offsetGroup) {
          // 180 derece dönüş (Math.PI radians)
          offsetGroup.rotation.z += Math.PI;
          // userData.rotate'i de güncelle (degrees)
          const newAngleDegrees = (offsetGroup.rotation.z * 180 / Math.PI) % 360;
          socketGroup.userData.rotate = newAngleDegrees;
        } else {
          console.warn('⚠️ Symetric: offsetGroup bulunamadı!');
        }
      }
    };

    const throttledMouseMove = throttleRAF(handleMouseMove);

    dom.addEventListener('mousedown', handleMouseDown);
    dom.addEventListener('mousemove', throttledMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    dom.addEventListener('click', handleClick);

    return () => {
      throttledMouseMove.cancel();
      dom.removeEventListener('mousedown', handleMouseDown);
      dom.removeEventListener('mousemove', throttledMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      dom.removeEventListener('click', handleClick);
    };
  }, [scene, camera, renderer, orthoMode]);
}
